import React from "react";
import { Route, Routes } from "react-router-dom";
import { HomePageURL } from "../assets/const";
import StoreDetail from "../pages/store/StoreDetail";
import StoreList from "../pages/store/StoreList";
import StoreOrders from "../pages/store/StoreOrders";
import StoreVisits from "../pages/store/StoreVisits";
import StoreUnderReviewList from "../pages/store/StoreUnderReviewList";

const StoreRoute = () => {
  return (
    <Routes>
      <Route path={`${HomePageURL}/stores/`} element={<StoreList />} />
      <Route path={`${HomePageURL}/stores/visits/`} element={<StoreVisits />} />
      <Route path={`${HomePageURL}/stores/orders/`} element={<StoreOrders />} />
      <Route
        path={`${HomePageURL}/stores/:storeSlug/`}
        element={<StoreDetail />}
      />
      <Route
        path={`${HomePageURL}/stores-under-review/`}
        element={<StoreUnderReviewList />}
      />
      <Route
        path={`${HomePageURL}/stores-under-review/:storeSlug/`}
        element={<StoreDetail />}
      />
    </Routes>
  );
};

export default StoreRoute;
